import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { useState } from "react";

export default function ToogleGroupField({
  label,
  value,
  options,
  onHandleStyleChange,
}) {
  return (
    <div className="flex flex-col">
      <label>{label}</label>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={(event, newValue) => onHandleStyleChange(newValue)}
        aria-label="text alignment"
      >
        {options.map((option, index) => (
          <ToggleButton title={option?.value} key={index} value={option?.value}>
            {option?.icon}
            {/* <FormatAlignLeftIcon /> */}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </div>
  );
}
